import { useLocation, useNavigate } from "@tanstack/react-router";
import { Bug } from "lucide-react";
import { ROUTES } from "../config/constants";

/**
 * ReportProblemButton — header button that navigates to ticket creation
 * with current route context pre-filled.
 *
 * Added to ContentHeader for quick access from any page.
 */
export function ReportProblemButton() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleClick = () => {
    navigate({
      to: ROUTES.TICKETS.CREATE,
      search: {
        from: location.pathname,
      },
    });
  };

  return (
    <div className="tooltip tooltip-bottom" data-tip="Reporter un problème">
      <button
        type="button"
        className="ghost-btn"
        aria-label="Reporter un problème"
        onClick={handleClick}
      >
        <Bug size={15} strokeWidth={1.8} />
      </button>
    </div>
  );
}
